<div [id]="field.attributes.id" (blur)="touch()">
  <clients-selector
    [clients]="clients"
    [(selected)]="value"
    [disabled]="disabled"
    [readonly]="readonly"
  ></clients-selector>
</div>
